import React from 'react';
import styles from '../styles/Spinner.style';
import withStyles from '../../../../../../common/hoc/withStyles';

const CircularSpinner = ({ className }) => {
  return (
    <div className={className}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        className="spinner"
      >
        {/* Background Circle */}
        <circle
          cx="50"
          cy="50"
          r="40"
          stroke="lightgreen"
          strokeWidth="8"
          fill="none"
          opacity="0.3"
        />
        {/* Animated Progress Circle */}
        <circle
          cx="50"
          cy="50"
          r="40"
          stroke="darkgreen"
          strokeWidth="8"
          fill="none"
          strokeDasharray="251.2"
          strokeDashoffset="100"
          strokeLinecap="round"
          className="spinner-progress"
        />
      </svg>
    </div>
  );
};

export default withStyles(CircularSpinner, styles);
